import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import LabelledInput from 'components/LabelledInput';
import Button from 'widgets/Button';
import Modal from 'components/Modal';
import {
  USER_INFO_KEYS
} from './config';
import defaultStyle from './style';
import './AdditionalInfoModal.scss';

class AdditionalInfoModal extends React.PureComponent {
  render() {
    const {
      errorInfoAuthForm,
      additionalInfo,
      closeAdditionalInfoModal,
      additionalInfoModalOpen,
      handleDobChange,
      handleAuthFormSave,
      handleAuthFormInputChange,
      userInfo,
      auth,
      intl
    } = this.props;
    return (
      <Modal
        title={intl.formatMessage({ id: 'views.subscriptionActivate.additionalInfoModal.title' })}
        open={additionalInfoModalOpen}
        toggleModal={closeAdditionalInfoModal}
        {...defaultStyle.modalStyleAdditionalInfo}
      >
        <div className="SubscriptionActivate__AdditionalInfo__Modal__Content">
          {
            !additionalInfo[USER_INFO_KEYS.DOB] &&
            <div className="SubscriptionActivate__AdditionalInfo__Modal__Content__InputWrap">
              <span>
                <FormattedMessage id="views.subscriptionActivate.additionalInfoModal.inputWrap.dob.label" />
              </span>
              <LabelledInput
                name={USER_INFO_KEYS.DOB}
                onChange={handleDobChange}
                iconName="dob"
                placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.additionalInfoModal.inputWrap.dob.placeholder' })}
                value={userInfo[USER_INFO_KEYS.DOB]}
                onEnter={handleAuthFormSave}
                errorText={errorInfoAuthForm[USER_INFO_KEYS.DOB] &&
                  intl.formatMessage({ id: errorInfoAuthForm[USER_INFO_KEYS.DOB] })}
                autoFocus
              />
            </div>
          }
          {
            !additionalInfo[USER_INFO_KEYS.FIRST_NAME] &&
            <div className="SubscriptionActivate__AdditionalInfo__Modal__Content__NameSection">
              <div className="SubscriptionActivate__AdditionalInfo__Modal__Content__InputWrap">
                <span><FormattedMessage id="views.subscriptionActivate.additionalInfoModal.inputWrap.firstName.label" /></span>
                <LabelledInput
                  name={USER_INFO_KEYS.FIRST_NAME}
                  onChange={handleAuthFormInputChange}
                  iconName="profile"
                  placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.additionalInfoModal.inputWrap.firstName.placeholder' })}
                  value={userInfo[USER_INFO_KEYS.FIRST_NAME]}
                  onEnter={handleAuthFormSave}
                  errorText={errorInfoAuthForm[USER_INFO_KEYS.FIRST_NAME] &&
                    intl.formatMessage({ id: errorInfoAuthForm[USER_INFO_KEYS.FIRST_NAME] })}
                />
              </div>
              <div className="SubscriptionActivate__AdditionalInfo__Modal__Content__InputWrap">
                <span><FormattedMessage id="views.subscriptionActivate.additionalInfoModal.inputWrap.lastName.label" /></span>
                <LabelledInput
                  name={USER_INFO_KEYS.LAST_NAME}
                  onChange={handleAuthFormInputChange}
                  placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.additionalInfoModal.inputWrap.lastName.placeholder' })}
                  value={userInfo[USER_INFO_KEYS.LAST_NAME]}
                  onEnter={handleAuthFormSave}
                  errorText={errorInfoAuthForm[USER_INFO_KEYS.LAST_NAME] &&
                    intl.formatMessage({ id: errorInfoAuthForm[USER_INFO_KEYS.LAST_NAME] })}
                />
              </div>
            </div>
        }
          <div className="SubscriptionActivate__AdditionalInfo__Modal__Content__Action">
            <Button
              id="SubscriptionActivate__AdditionalInfo__Action"
              cssStyles={{
                root: defaultStyle.AccountDetailsButtonStyle,
                label: defaultStyle.AccountDetailsButtonLabelStyle,
              }}
              className={`SubscriptionActivate__AdditionalInfo__Modal__Content__ActionButton ${(auth.isProcessingAuth && 'Disable') || ''}`}
              disabled={auth.isProcessingAuth}
              onClick={handleAuthFormSave}
            >
              <FormattedMessage id="views.subscriptionActivate.additionalInfoModal.actionButton" />
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

AdditionalInfoModal.propTypes = {
  errorInfoAuthForm: PropTypes.object.isRequired,
  additionalInfo: PropTypes.object.isRequired,
  closeAdditionalInfoModal: PropTypes.func.isRequired,
  handleDobChange: PropTypes.func.isRequired,
  handleAuthFormSave: PropTypes.func.isRequired,
  handleAuthFormInputChange: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  additionalInfoModalOpen: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(AdditionalInfoModal);



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AccountDetails/AdditionalInfoModal.jsx